import React from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import Modal from '../Modal';
import {disableEmployee} from '../../actions/ClientActions';

@connect(
    state => ({
        isDisablingEmployee: state.modal.isDisablingEmployee,
        hasError: state.modal.hasError
    }),
    dispatch => bindActionCreators({disableEmployee}, dispatch)
)
export default class ConfirmDisableEmployeeModal extends React.Component {
    handleDisable() {
        this.props.disableEmployee(this.props.client.id, this.props.user.employeeId);
    }
    render() {
        var actionButton = this.props.isDisablingEmployee ?
            (<button className="btn btn-danger disabled">Disabling...</button>) :
            (<button className="btn btn-danger" onClick={this.handleDisable.bind(this)}>Disable</button>);
        return (
            <Modal actionButton={actionButton} className="modal-danger" title={"Confirm you would like to disable employee"}>
                <p>Are you sure you would like to disable <strong>{this.props.user.name}</strong>?</p>
                {this.props.hasError && <p className='text-danger'>Error disabling employee!<br/>Please contact a member of the engineering team.</p>}
            </Modal>
        );
    }
}


// WEBPACK FOOTER //
// ./app/components/clients/ConfirmDisableEmployeeModal.js